import { render, staticRenderFns } from "./UserInfoDelete.vue?vue&type=template&id=015bedae&"
import script from "./UserInfoDelete.vue?vue&type=script&lang=js&"
export * from "./UserInfoDelete.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoDelete.vue?vue&type=style&index=0&id=015bedae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports